<template>
    <AdaptersDialog
        :listener-id="getDialogListenerOpenId"
        :listener-close-id="getDialogListenerCloseId"
        :header="$t('lang.main.delete_project')"
        :loading="loading"
        :error-message="error"
        :button-agree-label="$t('lang.main.btn.delete')"
        :callback-agree="deleteReport"
        :is-disable-send="isDisabledDelete"
    >
        <template #content>
            <div class="grid">
                <div class="col">
                    <TemplatesDisabledParentProjectsMessage
                        v-if="isDisabledDelete"
                        :monitoring-id="currentData.monitoring_id"
                        :monitoring-name="currentData.monitoring_name"
                    />
                    <div v-else class="flex flex-column">
                        <p>{{$t('lang.main.delete_project_promt', [currentData.name])}}</p>
                        <TemplatesChildProjectsList
                            v-if="hasChild"
                            v-model:isDeleteChilds="model.isDeleteChilds"
                            :projects="currentData.child_projects"
                        />
                    </div>
                </div>
            </div>
        </template>
    </AdaptersDialog>
</template>

<script>
import axios from 'axios'
import {Listeners} from "../../../constants/listeners";
import AdaptersDialog from "../../../component/adapters/Dialog.vue";
import TemplatesDisabledParentProjectsMessage from "../../../templates/DisabledParentProjectsMessage.vue";
import TemplatesChildProjectsList from "../../../templates/DeleteChildProjectsList.vue";
import ClusterApi from "../../../api/ClusterApi";
import Alerts from "../../../mixins/Alerts";

export default {
    mixins: [Alerts],
    data () {
        return {
            name: 'DeleteCluster',
            loading: false,
            error: null,
            currentData: {},
            model: {
                isDeleteChilds: false,
            }
        }
    },
    mounted() {
        this.$emitter.on(Listeners.KS_DELETE_PROJECT, eventData => this.onDeleteReport(eventData));
    },
    methods: {
        onDeleteReport(data) {
            this.currentData = data;
            this.$emitter.emit(this.getDialogListenerOpenId);
        },
        deleteReport() {
            this.loading = true;

            ClusterApi
                .deleteProject(this.currentData.uid, {childs: this.model.isDeleteChilds})
                .then(response => {
                    this.onClose();
                    this.$emitter.emit(Listeners.KS_FILTER_REFRESH);
                    this.$emitter.emit(Listeners.CLUSTER_LIST_RELOAD);
                })
                .catch(error => this.alertError(error))
                .finally(() => this.loading = false);
        },
        onClose() {
            this.$emitter.emit(this.getDialogListenerCloseId);
        },
    },
    computed: {
        getApiUrl() {
            return this.$config.API_URL + '/clustering/' + this.currentData.uid;
        },
        getDialogListenerOpenId() {
            return Listeners.KS_DELETE_PROJECT_OPEN;
        },
        getDialogListenerCloseId() {
            return Listeners.KS_DELETE_PROJECT_CLOSE;
        },
        isDisabledDelete() {
            return !!(this.currentData.monitoring_id);
        },
        hasChild() {
            return !!(this.currentData.child_projects.serp || this.currentData.child_projects.wordstat);
        },
    },
    components: {
        TemplatesDisabledParentProjectsMessage,
        AdaptersDialog,
        TemplatesChildProjectsList,
    }
}
</script>
